const ACTIVE_TRIGGER_CLASSES = ['border-ink', 'text-ink', 'font-semibold'];
const INACTIVE_TRIGGER_CLASSES = ['border-transparent', 'text-body-grey', 'font-normal'];

class ProtocolTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.triggers = [...this.querySelectorAll('[data-protocol-tab-trigger]')];
    this.panels = [...this.querySelectorAll('[data-protocol-tab-panel]')];

    if (this.triggers.length < 2) return;

    this.initialized = true;
    this.controller = new AbortController();
    const { signal } = this.controller;

    for (const trigger of this.triggers) {
      trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTarget), { signal });
      trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event), { signal });
    }

    document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.initialized = false;
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const isOwnTrigger = this.triggers.some((trigger) => trigger.dataset.tabTarget === blockId);
    if (!isOwnTrigger) return;

    this.activate(blockId);
  }

  onTriggerKeydown(event) {
    const { key } = event;
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

    event.preventDefault();
    const currentIndex = this.triggers.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.triggers.length;
    if (key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
    if (key === 'Home') nextIndex = 0;
    if (key === 'End') nextIndex = this.triggers.length - 1;

    const nextTrigger = this.triggers[nextIndex];
    this.activate(nextTrigger.dataset.tabTarget);
    nextTrigger.focus();
  }

  activate(targetId) {
    for (const trigger of this.triggers) {
      const isTarget = trigger.dataset.tabTarget === targetId;
      trigger.setAttribute('aria-selected', String(isTarget));
      trigger.setAttribute('tabindex', isTarget ? '0' : '-1');
      trigger.classList.remove(...(isTarget ? INACTIVE_TRIGGER_CLASSES : ACTIVE_TRIGGER_CLASSES));
      trigger.classList.add(...(isTarget ? ACTIVE_TRIGGER_CLASSES : INACTIVE_TRIGGER_CLASSES));
    }

    for (const panel of this.panels) {
      panel.hidden = panel.id !== targetId;
    }
  }
}

if (!customElements.get('protocol-tabs')) {
  customElements.define('protocol-tabs', ProtocolTabs);
}
